const countries = [
  {
    id: 'AR',
    icon: '🇦🇷',
  },
  {
    id: 'BR',
    icon: '🇧🇷',
  },
  {
    id: 'CL',
    icon: '🇨🇱',
  },
  {
    id: 'CO',
    icon: '🇨🇴',
  },
  {
    id: 'CR',
    icon: '🇨🇷',
  },
  {
    id: 'DO',
    icon: '🇩🇴',
  },
  {
    id: 'EC',
    icon: '🇪🇨',
  },
  {
    id: 'ES',
    icon: '🇪🇸',
  },
  {
    id: 'GB',
    icon: '🇬🇧',
  },
  {
    id: 'IT',
    icon: '🇮🇹',
  },
  {
    id: 'MX',
    icon: '🇲🇽',
  },
  {
    id: 'PA',
    icon: '🇵🇦',
  },
  {
    id: 'PY',
    icon: '🇵🇾',
  },
  {
    id: 'PE',
    icon: '🇵🇪',
  },
  {
    id: 'UY',
    icon: '🇺🇾',
  },
  {
    id: 'US',
    icon: '🇺🇸',
  },
];

export default countries;
